import { render, staticRenderFns } from "./BatchRunTable.vue?vue&type=template&id=a0c41fbe"
import script from "./BatchRunTable.vue?vue&type=script&lang=js"
export * from "./BatchRunTable.vue?vue&type=script&lang=js"
import style0 from "./BatchRunTable.vue?vue&type=style&index=0&id=a0c41fbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../CustomerOrder/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FBatchRun%2FBatchRun%2FBatchRunTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports